import React, { useContext, useEffect } from "react";
import styled from "styled-components";

import embraceImage from "../../../assets/images/homescreens/embrace-card-image.svg";
import { THEME_COLORS } from "../../../ThemeConfig";
import { Link } from "react-router-dom";
import { Context } from "../../../contexts/Store";

export default function EmbraceCard() {
    const { dispatch } = useContext(Context);

    useEffect(() => {
        dispatch({
            type: "CANCEL_ADD_SESSION",
        });
    }, []);

    return (
        <ImageCardDiv>
            <ImageTitleText>
                Embrace{" "}
                <ImageTitleSecondaryColor>
                    Mindfulness,
                </ImageTitleSecondaryColor>{" "}
                Elevate Your{" "}
                <ImageTitleSecondaryColor>Well-being</ImageTitleSecondaryColor>
            </ImageTitleText>
            <CardImage src={embraceImage} alt="image" />
            <ImageDivButton to="/create-session">Book a Session</ImageDivButton>
        </ImageCardDiv>
    );
}
const ImageCardDiv = styled.div`
    background: linear-gradient(165deg, ${THEME_COLORS.hero_bg_teal} 0%, ${THEME_COLORS.surface_soft} 100%);
    border-radius: 16px;
    padding: 28px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    border: 1px solid ${THEME_COLORS.light_300};
    box-shadow: ${THEME_COLORS.elevation_user_u4};
`;
const ImageTitleText = styled.h6`
    font-family: "DM_sans_medium";
    font-size: 20px;
    color: ${THEME_COLORS.text_title};
    width: 100%;
    text-align: center;
    margin: 0;
    line-height: 1.4;
`;
const ImageTitleSecondaryColor = styled.span`
    color: ${THEME_COLORS.primary};
`;
const CardImage = styled.img`
    margin-top: 16px;
    display: block;
    max-width: 100%;
    height: auto;
`;
const ImageDivButton = styled(Link)`
    display: inline-block;
    margin-top: 24px;
    background: ${THEME_COLORS.chips_green_on_container};
    border-radius: 24px;
    padding: 10px 20px;
    box-sizing: border-box;
    font-family: "DM_sans_medium";
    font-size: 15px;
    color: ${THEME_COLORS.white};
    width: fit-content;
    cursor: pointer;
    text-decoration: none;
    transition: opacity 0.2s, transform 0.15s;
    &:hover {
        opacity: 0.95;
        transform: translateY(-1px);
    }
`;
